import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { applicationMessages, toasterMessages } from '@messages/*';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/components/confirm-dialog/confirm-dialog.component';
import { DataService } from 'src/app/services/data.service';

enum PaymentStatus {
  FREETRAIL = 'Free Trial',
  PAID = 'Subscription Active',
  LOCK = 'Free Trial Expired',
  CANCEL_REQUESTED = 'Subscription Inactive'
}

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SettingsComponent implements OnInit {
  selectedTabIndex: number = 0;
  isSidebarMinimized: boolean = true;
  admins: any = [];
  invoices: any[];
  paymentStatus: string;
  subscriptionName: string = '';
  enterpriseId: string;
  roles: string[] = ['Super Admin', 'Admin'];
  rolesMap: { [key: string]: string } = {
    'Super Admin': 'ENTERPRISE_ADMIN',
    'Admin': 'ENTERPRISE_USER'
  };

  inviteEmailForm = this.fb.group({
    role: ['', Validators.required],
    adminIds: ['', [
      Validators.required,
      Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/)
    ]]
  });
  currentUser: any;

  constructor(
    private dashboardService: DashboardService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private router: Router,
    private dataService: DataService
  ) { }

  ngOnInit() {
    this.getprofile();
  }

  getprofile() {
    this.dashboardService.getUserProfile().subscribe((res: any) => {
      this.currentUser = res;
      if (this.currentUser.role !== 'ENTERPRISE_ADMIN') {
        this.roles = ['Admin'];
      }
    });
    this.dashboardService.getAdminProfile().subscribe((res: any) => {
      this.enterpriseId = res?._id;
      this.paymentStatus = PaymentStatus[res.paymentStatus];
      if (this.paymentStatus === PaymentStatus.PAID || this.paymentStatus === PaymentStatus.CANCEL_REQUESTED) {
        this.getInvoices();
      }
      this.subscriptionName = res?.plan?.name;
      this.admins = res?.admins || [];
    });
  }

  private getInvoices(): void {
    this.dashboardService.getInvoices().subscribe((res) => {
      this.invoices = res.invoices;
    });
  }

  inviteAdmins() {
    const email = this.inviteEmailForm.value.adminIds.trim();
    const ids = { userType: this.rolesMap[this.inviteEmailForm.value.role], emailId: email };
    this.dashboardService.inviteAdmins(this.enterpriseId, ids).subscribe((res) => {
      this.toastr.success(toasterMessages.inviteAdminSuccess);
      this.getprofile();
      this.inviteEmailForm.reset();
    });
  }

  deleteAdmin(admin, index) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { danger: true, messageBody: applicationMessages.adminDeleteConfirm }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        const ids = { emails: admin.email };
        this.dashboardService.unInviteAdmins(this.enterpriseId, ids).subscribe((res) => {
          this.toastr.success(toasterMessages.deleteAdminSuccess);
          this.admins.splice(index, 1);
        });
      }
    });
  }

  downloadInvoice(item) {
    window.open(item.shortUrl, 'blank');
  }

  cancelPaymentSub(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { danger: true, messageBody: applicationMessages.cancelSubscriptionConfirm }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.dashboardService.cancelSubscription().subscribe(() => {
          this.toastr.success(toasterMessages.cancelSubscriptionSuccess);
          this.getprofile();
        });
      }
    });
  }

  subscribePlan(): void {
    this.router.navigate(['dashboard/pricing']);
  }

  onTabChange(index: number): void {
    this.selectedTabIndex = index;
  }
}
